<template>
	<div class="featured-text" @click="$emit('click')">
		<slot name="icon"></slot>
		{{ text }}
	</div>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			default: "",
		},
	},
}
</script>

<style lang="scss" scoped>
.featured-text {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px 20px;
	gap: 10px;
	background-color: var(--btn-featured-bg-color);
	border-radius: 10px;
	font-size: 12px;
	line-height: 15px;
	text-align: center;
	color: var(--btn-featured-text-color);
	min-height: 61px;
	font-family: var(--head-bold);
	@media (min-width: 768px) {
		font-size: 20px;
		line-height: 24px;
		padding: 16px;
	}
}
</style>
